import { ExtraErrorData, HttpClient } from "@sentry/integrations";
import * as Sentry from "@sentry/react";

import logger from "@readai/common/logger";

import Config from "@app/booking/config";

const environment = import.meta.env.VITE_APP_STAGE || "development";
const disableSentry = import.meta.env.VITE_APP_DISABLE_SENTRY === "true";

const initializeSentry = () => {
  if (disableSentry) {
    logger.warn("sentry disabled since VITE_APP_DISABLE_SENTRY is set");
  }

  Sentry.init({
    dsn: Config.sentry.DSN,
    environment,
    enabled:
      !disableSentry &&
      (environment === "staging" || environment === "production"),
    release: import.meta.env.VITE_APP_SENTRY_RELEASE,
    // TODO: react router integration
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    integrations: [
      new ExtraErrorData(), // attempts to call toJSON on any error objects
      new HttpClient(), // for 5xx's logs request info from fetch
      new Sentry.BrowserTracing(), // navigation tracking
    ],
    tracesSampleRate: 0.0015, // adjust once we get more prod traffic
    ignoreErrors: [
      // Email link Microsoft Outlook crawler compatibility error
      // cf. https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062
      "Non-Error promise rejection captured with value: Object Not Found Matching Id:",
    ],
  });
};

export default initializeSentry;
